export default "__VITE_ASSET__B5xy7kau__"